import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { AgeGroup, DocumentReference } from '../../core/models';
import { 
  AgeGroupService, ArrayService, AuthService, ChurchService, DocumentService, 
  DatabaseService, MemberService, ServiceYearMemberService, FestivalUserService,  
} from 'src/core/services';
import { NgForm } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { PageClass } from 'src/core/classes/page';
import { TextService } from 'src/core/services/text-service';

@Component({
  selector: 'app-add-member',
  templateUrl: './add-member.component.html',
  styleUrls: ['./add-member.component.less', '../../core/styles/common.less']
})

export class AddMemberComponent extends PageClass implements OnInit {

  member: any = {
    isActive : true,
    isDeleted : false
  };
  memberGroup: any = {
    notes : '',
    isActive : true,
    isDeleted : false,
    choir : false,
    drama : false,
    it : false,
    media : false,
    visualArt : false
  };

  genderList: any[];
  groupList: DocumentReference [];
  priestList: DocumentReference [] = [];
  yearList: DocumentReference [];
  yesNoList: string[] = ['Yes', 'No'];

  isLoading = true;

  @Input() churchList: DocumentReference[];
  @Input() ageGroupList: DocumentReference[];

  @ViewChild('memberForm', null) memberForm: NgForm;
  @ViewChild('closeModal', null)  closeModal: ElementRef;

  constructor(
    protected ageGroupService: AgeGroupService,
    protected arrayService: ArrayService,
    protected authService: AuthService,
    protected churchService: ChurchService,
    protected databaseService: DatabaseService,
    private documentService: DocumentService,
    private memberService: MemberService,
    private serviceYearMemberService: ServiceYearMemberService,
    protected festivalUserService: FestivalUserService,
    private modalController: ModalController,
    private textService: TextService 
  ) {
    super(
      ageGroupService, arrayService, authService, 
      churchService, databaseService, festivalUserService
    );
  }

  protected loadData = async () => {
    if (this.currentUser.isActive && !this.currentUser.isDeleted) {
      if (!this.currentUser.isAdmin) {
        this.member.church = this.currentUser.church;
        this.memberGroup.church = this.currentUser.church;
      } else {
        this.member.church = null;
        this.memberGroup.church = null;
      }

      this.getPriestList();
      this.groupList = this.ageGroupList;

      if (this.groupList.length === 1) {
        this.memberGroup.ageGroup = this.groupList[0];
        this.populateYearList();
      } else {
        this.memberGroup.ageGroup = null;
      }

      this.genderList = this.memberService.getGenderList();
      this.member.gender = null;

      this.isLoading = false;
    }
  }

  async getPriestList() {
    (await this.festivalUserService.getPriests()).subscribe (priestList => {
      priestList.forEach(priest => {
        this.priestList.push(
          {
              reference: this.databaseService.doc(`${this.festivalUserService.collection}/${priest.id}`).ref,
              displayName: priest.user.displayName
          }
        );

        this.priestList.sort(this.arrayService.orderByDisplayName);
      });
    });

    this.member.fatherOfConfession = null;
  }

  async populateYearList() {
    const ageGroup = await this.documentService.getDocumentById('ageGroups', this.memberGroup.ageGroup.reference.id);
    this.yearList = (ageGroup as AgeGroup).yearLevelList;
    this.memberGroup.yearLevel = null;

    this.requireFatherOfConfession();
  }

  async addMember() {
    if (this.memberForm.invalid) {
      return;
    }

    this.member = { 
      ...this.member,
      firstName: this.textService.toPascalCase(this.member.firstName),
      lastName: this.textService.toPascalCase(this.member.lastName),
      createdBy : this.currentUser.user,
      createdAt : new Date().getTime(),
      updatedBy : this.currentUser.user,
      updatedAt : new Date().getTime()
    }

    await this.memberService.createMember(this.member)
      .then(
        (memberId) => {
          this.addMemberGroup(memberId);
        });
  }

  async addMemberGroup(memberId: string) {

    this.member.id = memberId;

    this.memberGroup = { 
      ...this.memberGroup,
      church : this.member.church,
      gender : this.member.gender,
      createdBy : this.currentUser.user,
      createdAt : new Date().getTime(),
      updatedBy : this.currentUser.user,
      updatedAt : new Date().getTime()
    }

    await this.serviceYearMemberService.createMemberGroup(this.memberGroup, this.member)
      .then (() => {
        this.memberForm.resetForm();
        alert('Member Successfully Created');

        this.dismissModal();
      });
  }

  requireFatherOfConfession() {
    const arrayList = ['1 - 3', 'Prep'];
    return this.memberGroup && this.memberGroup.ageGroup &&
     !arrayList.includes(this.memberGroup.ageGroup.displayName);
  }

  dismissModal() {
    this.modalController.dismiss();
  }
}
